<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      :title="$store.state.modal.editPeriodePenggajian"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Tanggal Awal" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('tanggalAwal')"
            v-model="$v.data.tanggalAwal.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Tanggal Akhir" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('tanggalAkhir')"
            v-model="$v.data.tanggalAkhir.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Tanggal Gajian" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('tanggalGajian')"
            v-model="$v.data.tanggalGajian.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="BPJS" label-cols-md="3">
          <b-form-radio-group
            id="radio-group-1"
            :state="checkIfValid('isBpjs')"
            v-model="$v.data.isBpjs.$model"
            :options="optionsBpjs"
            name="radio-options"
          ></b-form-radio-group>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "modalEdit",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Simpan",
      optionsBpjs: [
        {value: true, text: 'Ya'},
        {value: false, text: 'Tidak'},
      ],
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      tanggalAwal: { required, maxValue: maxValue(31) },
      tanggalAkhir: { required, maxValue: maxValue(31) },
      tanggalGajian: { required, maxValue: maxValue(31) },
      isBpjs: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = vm.$store.state.form.tunggu;
        vm.$axios
          .post("periodeGajiMitra/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              this.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA MASTER PENGGAJIAN",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = vm.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
